"use strict";

const NavBar = function () {
  var usersClosed = false;

  var initialize = function () {
    _showHideLoggedInMenus();
    _populateDropdowns();
    sharedInitialize();
  };

  var initializeEsg = function () {
    _checkFeatureFlag();
    _showHideLoggedInMenus();
    _populateDropdownsEsg();
    sharedInitialize();
  };

  var initializeReport = function () {
    _showHideLoggedInMenus();
    _populateReportDropdowns();
    sharedInitialize();
  };

  var sharedInitialize = function () {
    DataImport.init();
    DataExport.init();
    FeatureFlagModal.enableFeatureFlagModal();
  };

  var _checkFeatureFlag = function () {
    if (UserPermissions.getPermission("can_manage_users")) {
      $("#user-settings").html(nunjucks.render("modals/settingsModal/userManagementButton.njk"));
    }
  };

  var _showHideLoggedInMenus = function () {
    if (Session.isLoggedIn()) {
      $(".logged-in-only").removeClass("hidden");
      $(".logged-out-only").addClass("hidden");
    } else {
      $(".logged-in-only").addClass("hidden");
      $(".logged-out-only").removeClass("hidden");
    }
  };

  var _populateDropdowns = function () {
    _setupDropdowns();
    _initDropdownListeners();
  };

  var _populateDropdownsEsg = function () {
    _setupDropdownsEsg();
    _initDropdownListeners();
  };

  var _populateReportDropdowns = function () {
    _setupReportDropdowns();
    _initDropdownListeners();
  };

  var repopulateDropdowns = function () {
    $("#navbar-menu .dropdown .dropdown-menu").html("");
    initialize();
  };

  var _setupDropdowns = function () {
    _populateDropdown("import-export", []);

    const settings = getSettingsDropdownOptions();
    if (settings.length > 0) {
      _populateDropdown("settings", settings);
    } else {
      $("#navbar-menu .dropdown.settings").remove();
    }

    const helpDropdownOptions = [
      {
        class: "navbar-help-center",
        text: "Help Center",
        href: "https://kb.2ndnaturewater.com/_hcms/mem/login?redirect_url=https://kb.2ndnaturewater.com/knowledge",
        target: "_blank",
      },
      {
        class: "navbar-contact-support",
        text: "Contact Support",
        href: "https://kb.2ndnaturewater.com/knowledge/kb-tickets/new",
        target: "_blank",
      },
      {
        class: "upload-debug",
        text: "Upload Debug Report",
        target: "_blank",
      },
      {
        text: "ESWFT Resources",
        class: "navbar-eswft-resources",
        href: ToolSettings.getSetting("constants", "eswftUrl"),
        target: "_blank",
      },
      {
        text: "Asset Definitions",
        class: "navbar-bmp-definitions",
        href: "https://go.2ndnaturewater.com/hubfs/StormwaterGIS-2NDNATURE-Version1-09-2023.pdf",
        target: "_blank",
      },
    ];
    if (FeatureFlag.enabled("public-api-keys")) {
      helpDropdownOptions.push({
        text: "API Documentation",
        class: "navbar-api-documentation",
        href: "/docs",
        target: "_blank",
      });
    }
    _populateDropdown("help", helpDropdownOptions);

    const aliasList = ToolSettings.getSetting("alias");
    const userDropdownOptions = [
      { text: "User Profile", class: "show-user-profile" },
      { text: "Feature Flag Settings", class: "feature-flag-settings", defaultHidden: true },
      {
        class: "show-privacy-policy",
        text: "Privacy Policy",
        href: "https://drive.google.com/file/d/1NXiurl1Y11RVJ6NyPf1Xz-HYoRMR9KXy/view?usp=sharing",
        target: "_blank",
      },
      { text: "Sign Out", class: `sign-out ${aliasList?.length > 1 ? "list-divide" : ""}` },
    ];

    if (ToolSettings.getSetting("alias")?.length > 1) {
      userDropdownOptions.push({ html: '<select class="alias-more"></select>' });
    }

    _populateDropdown("user", userDropdownOptions);
  };

  var _setupDropdownsEsg = function () {
    const aliasList = ToolSettings.getSetting("alias");
    const userDropdownOptions = [
      { text: "User Profile", class: "show-user-profile" },
      { text: "Feature Flag Settings", class: "feature-flag-settings", defaultHidden: true },
      {
        class: "show-privacy-policy",
        text: "Privacy Policy",
        href: "https://drive.google.com/file/d/1NXiurl1Y11RVJ6NyPf1Xz-HYoRMR9KXy/view?usp=sharing",
        target: "_blank",
      },
      { text: "Sign Out", class: `sign-out ${aliasList?.length > 1 ? "list-divide" : ""}` },
    ];

    if (ToolSettings.getSetting("alias")?.length > 1) {
      userDropdownOptions.push({ html: '<select class="alias-more"></select>' });
    }

    _populateDropdown("user", userDropdownOptions);

    const helpDropdownOptions = [
      {
        class: "navbar-help-center",
        text: "Help Center",
        href: "https://kb.2ndnaturewater.com/_hcms/mem/login?redirect_url=https://kb.2ndnaturewater.com/knowledge/rainsteward",
        target: "_blank",
      },
      {
        class: "navbar-contact-support",
        text: "Contact Support",
        href: "https://kb.2ndnaturewater.com/knowledge/kb-tickets/new",
        target: "_blank",
      },
      {
        text: "Export Properties",
        class: "property-export-link",
      },
    ];
    _populateDropdown("help", helpDropdownOptions);
  };

  var _setupReportDropdowns = function () {
    _populateDropdown("import-export", [
      { text: "Import Data", class: "data-import-disabled-link disabled" },
      { text: "Export Data", class: "data-export-link" },
    ]);

    _populateDropdown("settings", [
      {
        text: "Group Settings",
        class: "page-link",
        data: [{ key: "page-name", value: "groupSettings" }],
      },
    ]);

    _populateDropdown("help", [
      {
        class: "navbar-help-center",
        text: "Help Center",
        href: "https://kb.2ndnaturewater.com/_hcms/mem/login?redirect_url=https://kb.2ndnaturewater.com/knowledge",
        target: "_blank",
      },
      {
        class: "navbar-contact-support",
        text: "Contact Support",
        href: "https://kb.2ndnaturewater.com/knowledge/kb-tickets/new",
        target: "_blank",
      },
      {
        class: "navbar-eswft-resources",
        text: "ESWFT Resources",
        href: ToolSettings.getSetting("constants", "eswftUrl"),
        target: "_blank",
      },
      {
        class: "navbar-bmp-definitions",
        text: "Asset Definitions",
        href: "https://go.2ndnaturewater.com/hubfs/StormwaterGIS-2NDNATURE-Version1-09-2023.pdf",
        target: "_blank",
      },
    ]);

    const aliasList = ToolSettings.getSetting("alias");
    const userDropdownOptions = [
      { text: "User Profile", class: "show-user-profile" },
      { text: "Feature Flag Settings", class: "feature-flag-settings", defaultHidden: true },
      {
        class: "navbar-privacy-policy",
        text: "Privacy Policy",
        href: "https://drive.google.com/file/d/1NXiurl1Y11RVJ6NyPf1Xz-HYoRMR9KXy/view?usp=sharing",
        target: "_blank",
      },
      { text: "Sign Out", class: `sign-out ${aliasList?.length > 1 ? "list-divide" : ""}` },
    ];

    if (ToolSettings.getSetting("alias")?.length > 1) {
      userDropdownOptions.push({ html: '<select class="alias-more"></select>' });
    }

    _populateDropdown("user", userDropdownOptions);
  };

  var _populateDropdown = function (dropdownName, defaultListItems) {
    if (Session.isLoggedIn()) {
      var listItems = [
        ...defaultListItems,
        ...MenuConfig.getCurrentMenuItems(dropdownName),
        ...MenuConfig.getGroupBasedMenuItems(dropdownName),
      ];

      if (Session.isRegulator()) {
        listItems = listItems.filter((item) => !item.regulatorHidden);
      }

      if (Session.isFieldPersonnel()) {
        listItems = listItems.filter((item) => !item.fieldPersonnelHidden);
      }

      listItems = MenuConfig.filterMenuItemsByPermission(listItems);
      MenuConfig.disableMenuItemsWithoutDataViewProperties(listItems);
    } else {
      listItems = defaultListItems;
    }

    const dropdownUser = nunjucks.render(`navbar/dropdown.njk`, {
      listItems,
    });
    $(`.dropdown.${dropdownName} .dropdown-menu`).html(dropdownUser);

    if (listItems.length === 0) {
      $(`.dropdown.${dropdownName}`).hide();
    }
  };

  var _initDropdownListeners = function () {
    const Login = require("./login/login");
    $(".sign-out").off("click", Login.logout);
    $(".sign-out").on("click", Login.logout);

    const $navbarMenu = $("#navbar-menu");

    $navbarMenu.off("shown.bs.dropdown", ".dropdown.user", _onUserDropdownOpen);
    $navbarMenu.on("shown.bs.dropdown", ".dropdown.user", _onUserDropdownOpen);

    $navbarMenu.off("hidden.bs.dropdown", ".dropdown.user", onUserDropdownClose);
    $navbarMenu.on("hidden.bs.dropdown", ".dropdown.user", onUserDropdownClose);

    $navbarMenu.off("click", "ul.dropdown-menu a", Analytics.sendNavClickEvent);
    $navbarMenu.on("click", "ul.dropdown-menu a", Analytics.sendNavClickEvent);

    $navbarMenu.off("click", "a.show-manage-users", ManageUsers.showManageUsersModal);
    $navbarMenu.on("click", "a.show-manage-users", ManageUsers.showManageUsersModal);

    $navbarMenu.off("click", "a.show-user-profile", UserSettingsFunctions.showUserSettingsModal);
    $navbarMenu.on("click", "a.show-user-profile", UserSettingsFunctions.showUserSettingsModal);

    $navbarMenu.off("click", "a.show-module-settings", ModuleSettingsController.open);
    $navbarMenu.on("click", "a.show-module-settings", ModuleSettingsController.open);

    $navbarMenu.off("click", "a.show-settings-modal", SettingsModalController.showSettingsModal);
    $navbarMenu.on("click", "a.show-settings-modal", SettingsModalController.showSettingsModal);

    $navbarMenu.off("click", "a.show-eswft-modal", EswftSyncStatusModal.showEswftSyncStatusModal);
    $navbarMenu.on("click", "a.show-eswft-modal", EswftSyncStatusModal.showEswftSyncStatusModal);

    $navbarMenu.off("click", "a.upload-debug", OfflineExporter.uploadOfflineData);
    $navbarMenu.on("click", "a.upload-debug", OfflineExporter.uploadOfflineData);

    UserSettingsFunctions.loadListeners();
    ManageUsers.loadListeners();
  };

  var onSelectAlias = function (e) {
    const SingleSignOn = require("./login/sso");
    const BrowserWarning = require("./general/browserWarning");
    const aliasId = e.params.data.id;

    if (!BrowserWarning.confirmCanClose("switch accounts")) {
      return;
    }

    SingleSignOn.selectAlias({ aliasId: aliasId });
  };

  var getSettingsDropdownOptions = function () {
    const options = [];

    if (SettingsModalController.canAccessSettings()) {
      options.push({ text: "System Settings", class: "show-settings-modal" });
    }

    if (
      UserPermissions.getPermission("can_manage_users") &&
      FeatureFlag.enabled("old-user-management")
    ) {
      options.push({ text: "Old User Management", class: "show-manage-users" });
    }

    if (Session.is2nAdmin()) {
      options.push({ text: "Module Settings", class: "show-module-settings" });
      options.push({
        text: "ESWFT Sync Status",
        class: "show-eswft-modal",
      });
    }

    return options;
  };

  var _onUserDropdownOpen = function (e) {
    const aliasList = ToolSettings.getSetting("alias");

    if (!aliasList) {
      return;
    }

    usersClosed = false;
    $(".dropdown.user select.alias-more")
      .select2({
        data: aliasList.map(function (alias) {
          return {
            text: `${alias.gname} - ${alias.role}`,
            selected: alias.active,
            id: alias.id,
          };
        }),
        width: "resolve",
        minimumResultsForSearch: 6,
        dropdownCssClass: "select2-user-dropdown dropdown-menu",
        selectionCssClass: "select2-user-selection",
        dropdownParent: $(".dropdown.user"),
      })
      .off("select2:select", onSelectAlias)
      .on("select2:select", onSelectAlias)
      .off("select2:closing", onSelectClosing)
      .on("select2:closing", onSelectClosing)
      .select2("open");
  };

  // Prevent closing when focus is lost
  var onSelectClosing = function (e) {
    return usersClosed;
  };

  var onUserDropdownClose = function (e) {
    usersClosed = true;
    $(".dropdown.user select.alias-more").select2("close");
  };

  return {
    initialize,
    initializeEsg,
    initializeReport,
    repopulateDropdowns,
    _onUserDropdownOpen,
  };
};

module.exports = NavBar();

const MenuConfig = require("./config/menuConfig");
const DataExport = require("./dataExport/dataExport");
const DataImport = require("./dataImport/dataImport");
const Analytics = require("./general/analytics");
const Session = require("./login/session");
const UserPermissions = require("./login/userPermissions");
const ManageUsers = require("./modals/manageUsers");
const UserSettingsFunctions = require("./modals/userSettingsFunctions");
const FeatureFlagModal = require("./settings/featureFlagModal");
const EswftSyncStatusModal = require("./settings/eswftSyncStatusModal");
const ToolSettings = require("./settings/toolSettings");
const ModuleSettingsController = require("./settings/moduleSettings/moduleSettingsController");
const SettingsModalController = require("./settings/settingsModalController");
const FeatureFlag = require("./settings/featureFlag");
const OfflineExporter = require("./offline/offlineExporter");
